const MixpanelEventTypes = {
    translation: {
        clickedOnTranslationButton: 'Machine translation - translated',
        clickedOnCancelledTranslationButton: 'Machine translation - show original'
    },
    education: {
        educationTooltipShow: 'Machine translation CTA education show'
    }
};

module.exports = {
    MixpanelEventTypes
};
